import React from 'react';
import GridLayout, {Layout} from 'react-grid-layout';
import {Camera, Vehicle} from '../types';
import EmptyLayout from './EmptyLayout';
import Streaming from './Streaming';

type Props = {
  width: number,
  height: number,
  selected: Map<string, Camera>,
  vehicles: Map<string, Vehicle>
}
type LayoutOptions = {
  colsPerRow: number,
  layoutProto: { w: number, h: number }
}

const CastingLayout = ( props: Props ) => {
  let layoutOptions: LayoutOptions = {
    colsPerRow: 1,
    layoutProto: { w: 12, h: 12 }
  };
  const {selected, vehicles, width, height} = props;
  const generatelayout = ( opts: LayoutOptions ): Layout[] => {
    let y: number = 0;
    let x = 0;
    const { colsPerRow, layoutProto } = opts;
    const result: Layout[] = [];
    selected.forEach( ( _cam: Camera, key: string ) => {
      if ( x === colsPerRow ) {
        y += 1;
        x = 0;
      };
      result.push( {
        ...layoutProto,
        i: key,
        x: x * layoutProto.w,
        y
      });
      x++;
    });
    return result;
  }
  let sreamingDimensions: {width: number, height: number} = {
    width,
    height
  }
  let colNum = 0;
  const getStreams = ( style: {width: number, height: number} ) => {
    const result: JSX.Element[] = [];
    const getVehicleName = ( vehicleId: string ) => {
      console.warn({vehicleId});
      const vehicle = vehicles.get( vehicleId );
      return vehicle ? vehicle.title : 'undefined';
    };
    selected.forEach( ( cam: Camera, key: string ) => {
      result.push(<div key={key} >
        <Streaming
          style={style}
          vehicleName={getVehicleName( cam.vehicleId )}
          camera={cam}
        />
      </div>)
    });
    return result;
  }
  if ( selected.size === 0 ) {
    return <EmptyLayout width={width} height={height}/>;
  } else if ( selected.size === 1 ) {
    layoutOptions = {
      colsPerRow: 1,
      layoutProto: { w: 1, h: 1 }
    }
    colNum = 1;
    sreamingDimensions = {
      width,
      height
    }
  } else if ( selected.size === 2 ) {
    layoutOptions = {
      colsPerRow: 1,
      layoutProto: { w: 2, h: 1 }
    };
    colNum = 2;
    sreamingDimensions = {
      width,
      height: Math.floor( height / 2 )
    }
  } else if ( selected.size <= 4 ) {
    layoutOptions = {
      colsPerRow: 2,
      layoutProto: { w: 1, h: 1 }
    };
    colNum = 2;
    sreamingDimensions = {
      width: Math.floor( width / 2 ),
      height: Math.floor( height / 2 )
    }
  } else if ( selected.size <= 9 ) {
    layoutOptions = {
      colsPerRow: 3,
      layoutProto: { w: 1, h: 1 }
    };
    colNum = 3;
    sreamingDimensions = {
      width: Math.floor( width / 3 ),
      height: Math.floor( height / 3 )
    }
  } else if ( selected.size <= 16 ) {
    layoutOptions = {
      colsPerRow: 4,
      layoutProto: { w: 1, h: 1 }
    };
    colNum = 4;
    sreamingDimensions = {
      width: Math.floor( width / 4 ),
      height: Math.floor( height / 4 )
    }
  }
  const layout = generatelayout( layoutOptions );
  return (<GridLayout
    className='CastingLayout'
    layout={layout}
    cols={colNum}
    rowHeight={Math.floor( height / colNum )}
    width={width}
    isResizable={false}
    isDraggable={selected.size !== -1}
    margin={[ 0, 0 ]}>
    {getStreams( sreamingDimensions )}
  </GridLayout>);
};

export default CastingLayout;
